import Yeti from './Yeti';
import Dodo from './Dodo';
import Alista from './Alista';
export const PetType = {
  Yeti,
  Dodo,
  Alista
};
